import React, { useState, useEffect } from 'react';
import style from './MyInfoWrite.module.css';
import HeadSub from '../../../components/comm/HeadSub';
import URL from "../../../constants/url";
import { useLocation, useNavigate } from "react-router-dom";
import ToastPopup from '../../../components/comm/ToastPopup';
import {getDpNiceRequest} from "../../../assets/js/comm";

const MyInfoWrite = () => {
    const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

    const navigate = useNavigate();

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const location = useLocation();
    const { state } = location;

    const successYn = state?.successYn ?? null;
    const successMsg = state?.successMsg ?? null;

    useEffect(() => {
        if (!successYn) return;
        setToastMessage(successMsg || "등록이 완료되었습니다.");
        setToast(true);

        navigate(location.pathname, { replace: true, state: {} });
    }, [successYn, successMsg]);

    useEffect(() => {
        if (!location.state?.cameFromNice) return;

        const onPopState = () => {
            debugger;
            navigate(URL.APP_SETTINGS, { replace: true });
        };

        window.history.pushState(null, '', window.location.href);
        window.addEventListener('popstate', onPopState);

        return () => {
            window.removeEventListener('popstate', onPopState);
        };
    }, [location.state, navigate]);


    const withdrawBtn = () => {
        navigate(URL.MY_INFO_WITHDRAW)
    }

    const formatBrthdy = (dateStr) => {

        if (!dateStr) return '';

        return dateStr.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1.$2.$3');
    }

    const addHidden = (form, name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.id = name;
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }

    const submitToNice = ({ action, tokenVersionId, encData, integrity, service, openPopup = true, echo = {} }) => {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = action;
        // form.acceptCharset = 'UTF-8';

        if (openPopup) {
            // 팝업 차단 방지: 사용자 클릭 이벤트 안에서 window.open 먼저 호출
            window.open('', 'nicePopup', 'width=430,height=640,menubar=no,toolbar=no,location=no,status=no,scrollbars=yes');
            form.target = 'nicePopup';
        }

        addHidden(form, 'token_version_id', tokenVersionId);
        addHidden(form, 'enc_data', encData);
        addHidden(form, 'integrity_value', integrity);
        if (service) addHidden(form, 'm', 'service');
        addHidden(form, 'param_popup_yn', openPopup ? 'Y' : 'N');

        Object.entries(echo).forEach(([k, v]) => addHidden(form, k, v));

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form); // DOM 정리(선택)
    }


    /**
     * 뒤로가기 링크 액션
     */
    const handlOnBack = () => {
        const from = location.state?.from;
        if (from) {
            navigate(from, { replace: true }); // 히스토리 정리
        } else {
            navigate(URL.APP_SETTINGS, { replace: true });
        }
    };


    return (
        <>
            <HeadSub title="내 정보 수정" onBack={handlOnBack} />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    <div className={style['content-box']}>
                        <strong>기본 정보</strong>
                        <div className={style['inner-box']}>
                            <ul>
                                <li>
                                    <p>이름</p>
                                    <div className={style['right']}>
                                        <span>{loginUser?.usrNm}</span>
                                    </div>
                                </li>
                                <li>
                                    <p>생년월일</p>
                                    <div className={style['right']}>
                                        {/* <span>1998.12.22</span> */}
                                        <span>{formatBrthdy(loginUser?.brthdy)}</span>
                                    </div>
                                </li>
                                <li>
                                    <p>휴대전화번호</p>
                                    <div className={style['right']}>
                                        {/* <span>01012345678</span> */}
                                        <span>{loginUser?.mblNo}</span>
                                        <button className='btn' data-btn-type="fill-main" data-btn-size='xsmd'
                                                onClick={() => getDpNiceRequest("PHONE_OTP")}
                                        >
                                            <span>휴대전화번호 변경</span>
                                        </button>
                                    </div>
                                </li>
                                {/* <li>
                                    <p>서비스 고유코드</p>
                                    <div className={style['right']}>
                                        <span>IITP{loginUser.usrInfoId}DGTP</span>
                                    </div>
                                </li> */}
                            </ul>
                        </div>
                    </div>


                    <div className={style['content-box']}>
                        <strong>현재 로그인 정보</strong>
                        <div className={style['inner-box']}>
                            <ul>
                                <li>
                                    <p>로그인 수단</p>
                                    <div className={style['right']}>
                                        <span>아이디/비밀번호</span>
                                    </div>
                                </li>
                                <li>
                                    <p>아이디</p>
                                    <div className={style['right']}>
                                        <span>{loginUser?.usrId}</span>
                                    </div>
                                </li>
                                <li>
                                    <p>비밀번호</p>
                                    <div className={style['right']}>
                                        <button className='btn' data-btn-type="fill-main" data-btn-size='xsmd' onClick={() => navigate(URL.CHANGE_PASSWORD)}>
                                            <span>비밀번호 변경</span>
                                        </button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>


                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className={style['btn-group']}>
                                <button onClick={withdrawBtn}>
                                    <span>탈퇴하기</span>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                />
            )}
        </>
    );
};

export default MyInfoWrite;
